export async function graphRequest(
  query: string,
  variables: {},
  url: string,
): Promise<Response> {
  return fetch(url, {
    mode: 'cors',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify({
      query,
      variables,
    }),
  });
}
